/* istanbul ignore file */
import _ from 'lodash'
import fetch from '@adc/fetch'
import { gql } from '@adc/sdk'
import {
  Address,
  AddressInput,
  LeadIntakeInput,
  LeadIntake,
  LeadIntakePersonInput,
  LeadIntakePerson,
} from '@adc/sdk/types'

export const upsertLeadIntake = (payload: { input: LeadIntakeInput }) =>
  fetch
    .forAuctionGraph<'upsertLeadIntake', LeadIntake>({
      query: gql`
        mutation resiFeOnBoarding_upsertLeadIntake($input: LeadIntakeInput!) {
          upsertLeadIntake(input: $input) {
            lead_intake_id
            email
            first_name
            last_name
            middle_name
            phone
            sync_status
            properties {
              lead_intake_property_id
              listing_id
              property_id
              relationship_to_property
              agent_email
              agent_first_name
              agent_last_name
              agent_phone
              seller_intent
              property_type
              occupancy_status
              occupancy_description
              condition
              sale_timeline
              apn
              desired_amount
              home_square_footage
              street_number
              address
              program_type
              lot_size
              unit_number
              address_source
              country_code
            }
          }
        }
      `,
      variables: payload,
    })
    .then(res => {
      const errors = _.get(res, 'body.errors[0]')
      if (errors) throw errors
      return res.body.data.upsertLeadIntake
    })

// TODO: Serializing this here so we can use it as a quick cache key in memory to avoid duplicate
// calls on similiar addresses.
//
// const cheapCacheKey = Object.keys(address).sort()
//   .map(key => [key, address[key].trim()].join('='))
//   .join(';')

export const checkAvailabilityAndStandardizeAddress = (address: AddressInput) =>
  fetch
    .forAuctionGraph<'address_validate', Address>({
      query: gql`
        query resiFeOnBoarding_checkAvailabilityAndStandardizeAddress(
          $address: AddressInput!
        ) {
          address_validate(input: $address) {
            street_number
            street_name
            street_unit
            municipality
            country_secondary_subdivision
            country_primary_subdivision
            country_code
            postal_code
            source
          }
        }
      `,
      variables: { address },
    })
    .then(res => res.body.data?.address_validate ?? null)

export const upsertLeadIntakePerson = (input: LeadIntakePersonInput) => {
  // TODO hit a new BE endpoint with the data
  return fetch
    .forAuctionGraph<'upsertLeadIntakePerson', LeadIntakePerson>({
      query: gql`
        mutation resiFeOnBoarding_upsertLeadIntakePerson(
          $input: LeadIntakePersonInput!
        ) {
          upsertLeadIntakePerson(input: $input) {
            lead_intake_person_id
          }
        }
      `,
      variables: { input },
    })
    .then(res => {
      const errors = _.get(res, 'body.errors[0]')
      if (errors) throw errors
      return res.body.data.upsertLeadIntakePerson
    })
}
